import React from 'react';
import { Button } from '@brighterion/br-ui';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { useTranslation } from 'react-i18next';
import { RoleService } from 'Services';
import useAddNewList from 'Hooks/query-hooks/list/useAddNewList';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';
import styles from './Header.css';
import AddListModal from '../AddListModal';

const Header = () => {
    const { t } = useTranslation();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const addList = () => {
        setModalIsOpen(true);
    };

    const mutation = useAddNewList({
        mutationOptions: {
            onSuccess: () => {
                setModalIsOpen(false);
            }
        }
    });

    return (
        <div className={styles.listManagementHeader}>
            <div className={styles.leftContainer}>
                <div data-testid='list-management-page-title' className={styles.titleText}>
                    {t('Lists')}
                </div>
                {RoleService.isListAdmin() ? (
                    <Button
                        variant='secondary'
                        size='small'
                        className={styles.addListButton}
                        onClick={handleOnClickEvent(addList)}
                        onKeyDown={handleKeyEvent(addList)}
                    >
                        {t('Add List')}
                    </Button>
                ) : null}
                <AddListModal
                    isLoading={mutation.isLoading}
                    handleSubmit={(values) => {
                        mutation.mutate(values);
                        trackEvent({
                            eventType: EventTypes.track,
                            eventName: EventNames.click,
                            payload: {
                                clickIdentifier: 'Lists - Add List',
                                text: 'Add List'
                            }
                        });
                    }}
                    isOpen={modalIsOpen}
                    closeModal={() => {
                        setModalIsOpen(false);
                    }}
                    resetError={mutation.reset}
                    error={mutation.error}
                />
            </div>
        </div>
    );
};

export default Header;
